import React from 'react';
import { Header, Footer } from '../Common';
import CollectionShop from '../../Common/CollectionShop/CollectionShop';

/** CLS-SE public collection-shop listing (/clothing/cls-se/collection/:collectionSlug). */
const CLSSECollectionShop = () => (
  <CollectionShop
    brandSlug="clsse"
    feSlug="cls-se"
    dataBrand="CLS"
    HeaderComponent={Header}
    FooterComponent={Footer}
    packageDescription="Paketlösning"
    loadingText="Laddar produkter…"
    emptyTitle="Inga produkter just nu"
    emptyText="Kollektionen kanske uppdateras just nu. Har du frågor hjälper vi gärna till."
    contactLabel="Kontakta oss"
    faqLabel="Se FAQ"
  />
);

export default CLSSECollectionShop;
